import ScreenContainer from '../../display/ui/ScreenContainer';
import LoadBar from './LoadBar';

// empty group that will automatically center itself
export default class LoadDisplay extends ScreenContainer {
  constructor(game) {
    super(game, { background: 'bg_loading' });

    this.onAnimationComplete = new Phaser.Signal();

    // bee
    this.bee = this.game.make.spine(
      this.game.defaultWidth * 0.5,
      this.game.defaultHeight * 0.5,
      'spine_preloader'
    );
    this.bee.anchor.set(0.5, 1);
    this.bee.setAnimationByName(0, 'idle', true);
    this.addChild(this.bee);

    // add load bar
    this.loadBar = new LoadBar(this.game);
    this.loadBar.x = this.game.defaultWidth * 0.5 - this.loadBar.width * 0.5;
    this.loadBar.y = 510;
    this.add(this.loadBar);
  }

  setProgress(value) {
    this.loadBar.setProgress(Math.max(0, Math.min(1, value)));
  }

  setProcessing() {
    this.loadBar.setProcessing();
  }

  animateCompleteSequence(options) {
    const { delay = 500, duration = 200 } = options;
    this.animateOutTween = this.game.add
      .tween(this)
      .to({ alpha: 0 }, duration, Phaser.Easing.Quadratic.Out, true, delay);

    this.animateOutTween.onComplete.add(this.handleAnimateSequenceComplete, this);
  }
  handleAnimateSequenceComplete() {
    this.onAnimationComplete.dispatch();
  }

  destroy() {
    this.onAnimationComplete.removeAll();
    if (this.animateOutTween) {
      this.animateOutTween.stop();
      this.game.tweens.remove(this.animateOutTween);
    }
    this.loadBar.destroy();

    // this.tadpole.destroy();
    // this.tadpole = null;

    this.onAnimationComplete = null;
    this.animateOutTween = null;
    this.loadBar = null;
    super.destroy(true);
  }
}
